/* eslint-disable max-len */
import React from 'react';
import { Checkbox } from 'common/checkbox';
import { InfoLabel } from 'common/info-label';
import { Accordion } from 'common/accordion';
import { QuestionsManagmentViewType } from 'common/enums';
import { classnames } from 'helpers/utils';
import { ThreeStatesCheckbox } from 'common/checkbox-three-states';
import { HelperText } from 'common/helper-text';
import { CheckIcon } from 'assets/icons';
import styles from './pre-built-item.module.scss';

type PreBuiltItemProps = {
  item: PreBuiltQuestionsType;
  questionsManagmentView: QuestionsManagmentViewType;
  selectPreBuiltItem: (PreBuiltId: string) => void;
  selectQuestion: (PreBuiltId: string, questionName: string) => void;
  hideCategorySelector?: boolean;
};

const PreBuiltItem: React.FC<PreBuiltItemProps> = ({
  item,
  questionsManagmentView,
  selectPreBuiltItem,
  selectQuestion,
  hideCategorySelector,
}) => {
  const preBuiltItemTitle = () => (
    <div className={styles.title}>
      <HelperText
        className="text__body__semi__bold__medium__gray800"
        content={item?.name!}
      />
      {!hideCategorySelector && (
        <div className={styles.selectCategory}>
          <ThreeStatesCheckbox
            itemKey={item?.id!}
            onChange={() => selectPreBuiltItem(item!.id)}
            checkValue={item?.checkValue}
          />
          <span className="text__body__regular__small__gray800">
            {questionsManagmentView === QuestionsManagmentViewType.myTemplates
              ? 'Select Template'
              : 'Select Category'}
          </span>
        </div>
      )}
    </div>
  );

  const preBuiltItemContent = () => (
    <div className={styles.content}>
      {item.questions!.map((question) => (
        <div key={question.name} className={styles.question}>
          <Checkbox
            itemKey={question.name}
            onChange={() => selectQuestion(item.id, question.name)}
            isChecked={question.isSelected}
          />
          <HelperText content={question?.name!} />
          {question.alreadyAdded && (
            <InfoLabel
              withIcon={false}
              content="Added"
              className={classnames(
                'text__body__regular__overline__brand700',
                styles.questionAdded,
              )}
              finalIcon={<CheckIcon className={styles.icon} />}
            />
          )}
        </div>
      ))}
    </div>
  );

  return (
    <Accordion
      className={styles.preBuiltItemContainer}
      title={preBuiltItemTitle()}
      content={preBuiltItemContent()}
    />
  );
};

export { PreBuiltItem };
